import { anzeigeName, kuerzel, personFarbe } from "./zusammenarbeit"

/** Rundes Kürzel einer Person. Ohne Person: gestrichelter Kreis mit „+". */
export function PersonPunkt({ name, groesse = 22, titel }: { name?: string | null; groesse?: number; titel?: string }) {
  const leer = !name
  return (
    <span
      className={leer ? "ev2-person ev2-person-leer" : "ev2-person"}
      title={titel ?? (leer ? "Noch niemand zuständig" : `Zuständig: ${anzeigeName(name)}`)}
      style={{
        width: groesse, height: groesse, borderRadius: groesse / 2,
        fontSize: groesse >= 28 ? 12 : 10.5,
        background: leer ? "transparent" : personFarbe(name),
      }}
      aria-hidden={titel ? undefined : true}
    >
      {kuerzel(name)}
    </span>
  )
}
